'use strict'
import ViewBase from '../../../view-base.view'
import { Dialog, Button } from 'construct-ui';
import loginModel from '../../../../models/login.model'
import projectModel from "../../../../models/custom-vision/custom-vision.projects.model";
import CVProjectAddView from '../projects/custom-vision.projects-add.view';
import CVProjectEditView from '../projects/custom-vision.projects-edit.view';
import CVTagsListView from '../cvtags/custom-vision.tags-list.view';
import CVDisplaysListView from '../displays/custom-vision.displays-list.view';
import CVIterationsListView from '../cvtrains/custom-vision.iterations-list.view';

export default function CVProjectsListView() {
    ViewBase.call(this);

    let currentCountry;

    let _isLoadingProjectsAndQuotaInfo = false;
    let _listOfProjects = [];

    let _projectQuota = 0;
    let _numberOfEmptySlots = 0;

    let isPopupAddNewProjectOpened = false;
    let isPopupEditProjectOpened = false;
    let isPopupListTagsOpened = false;
    let isPopupListDisplaysOpened = false;
    let isPopupListIterationsOpened = false;

    let selectedProjectId = 0;

    let _getProjectQuota = () => {
        projectModel.getProjectQuota(
            (result) => {
                _projectQuota = result[0].value;
                _numberOfEmptySlots = _projectQuota - _listOfProjects.length;

                this.hideLoading();
                _isLoadingProjectsAndQuotaInfo = false;
            }, (error) => {
                this.hideLoading();
                _isLoadingProjectsAndQuotaInfo = false;

                this.handleError(error);
            });
    }

    let _loadProjects = () => {
        this.showLoading();
        _isLoadingProjectsAndQuotaInfo = true;

        projectModel.getProjectsList(
            (result) => {
                var list = result;

                _getProjectQuota();
                
                if (list.length == 0) {
                    _listOfProjects = [];
                } else {
                    _listOfProjects = list;
                }

            }, (error) => {
                this.hideLoading();
                _isLoadingProjectsAndQuotaInfo = false;

                _listOfProjects = [];

                this.handleError(error);
            }
        );
    }

    let _createNewProject = () => {
        isPopupAddNewProjectOpened = true;
    }

    let onCreateNewProjectComplete = () => {
        isPopupAddNewProjectOpened = false;
        _loadProjects();
    }

    let _showEditProjectPopup = (projectId) => {
        isPopupEditProjectOpened = true;
        selectedProjectId = projectId;
    }

    let _showDeleteProjectConfirmation = (projectId) => {
        this.showConfirm(this.getText("LT00000125", "Are you sure you want to delete this project?"), this.getText("LT00000126", "Delete Project"), (e) => {
            
            if (e == "YES") {
                projectModel.deactivateProject(
                    () => {
                        this.showMessage(this.getText("LT00000127", "The project has been deleted."), this.getText("LT00000126", "Delete Project"));
                
                        _loadProjects();  
                    }, (error) => {                        
                        this.handleError(error);
                    },
                    projectId);
            }
          });

    }

    let _showListTagsPopup = (projectId) => {
        isPopupListTagsOpened = true;
        selectedProjectId = projectId;
    }

    let _showListDisplaysPopup = (projectId) => {
        isPopupListDisplaysOpened = true;
        selectedProjectId = projectId;
    }

    let _showListIterationsPopup = (projectId) => {
        isPopupListIterationsOpened = true;
        selectedProjectId = projectId;
    }

    let onEditProjectComplete = () => {
        isPopupEditProjectOpened = false;        
        _loadProjects();
    }

    let _showTrainingPhotosPage = () => {};

    return {
        oninit: (vnode) => {

            if (vnode.attrs.showTrainingPhotosPage) {
                _showTrainingPhotosPage = vnode.attrs.showTrainingPhotosPage;
            }
            
            currentCountry = loginModel.credentials.country;

            _loadProjects();

        },
        onupdate: (vnode) => {
            if (loginModel.credentials.country !== currentCountry) {
                
                _loadProjects();
                currentCountry = loginModel.credentials.country;
            }
        }, 
        view: ({ attrs }) => {

            let isSNeededForProjectWord = _listOfProjects.length != 1;
            let isSNeededForSlotWord = _numberOfEmptySlots != 1;

            return m('.col-md-12',
            [   
                m('.d-flex',
                    m('div',
                        m('button.btn.btn-outline-primary',  
                            { onclick: _createNewProject }, [
                                m("i.bi.bi-plus-lg.me-0")
                            ]
                        
                        )
                    )
                ),
                m('.card.mb-3.mt-2', 
                    m('.card-body.py-3', 
                        m('.row', 
                            m('.container', 
                            [
                                _listOfProjects.length > 0 && _numberOfEmptySlots >= 3 && m('.alert.alert-success', { role: 'alert' }, [
                                    m('h4.alert-heading', 'Project Quota'),
                                    m('p', [
                                        m('span', 'You have created ' + _listOfProjects.length + ' project' + (isSNeededForProjectWord ? 's' : '') + '. '),
                                        m('span', 'There are now '),
                                        m('strong', _numberOfEmptySlots + ' empty slot' + (isSNeededForSlotWord ? 's' : '') + ' left'),
                                        m('span', ' for your future new project' + (isSNeededForSlotWord ? 's' : '') + '. ')
                                    ]),
                                    
                                ]),
                                _numberOfEmptySlots > 0 && _numberOfEmptySlots < 3 && m('.alert.alert-warning', { role: 'alert' }, [
                                    m('h4.alert-heading', 'Low on Project Quota'),
                                    m('p', [
                                        m('span', 'You are already having ' + _listOfProjects.length + ' project' + (isSNeededForProjectWord ? 's' : '') + '. '),
                                        m('span', 'There are now only '),
                                        m('strong', _numberOfEmptySlots + ' empty slot' + (isSNeededForSlotWord ? 's' : '') + ' left'),
                                        m('span', ' for your future new project' + (isSNeededForSlotWord ? 's' : '') + '. ')
                                    ]),
                                    
                                ]),
                                !_isLoadingProjectsAndQuotaInfo && _numberOfEmptySlots <= 0 && m('.alert.alert-danger', { role: 'alert' }, [
                                    m('h4.alert-heading', 'Zero Empty Slot'),
                                    m('p', [
                                        m('span', 'You are already having ' + _listOfProjects.length + ' project' + (isSNeededForProjectWord ? 's' : '') + '. '),
                                        m('span', 'There are now '),
                                        m('strong', 'no more empty slot left'),
                                        m('span', ' for your future new projects. You can delete unused projects to free up the space. ')
                                    ]),
                                    
                                ]),
                                m('div', { "class": "" },
                                    _listOfProjects.length == 0 && m('span', this.getText("EM00000141", "No records found.")),
                
                                    _listOfProjects.length > 0 && m("div", { "class": "col-md-12" },
                                    [
                                        _listOfProjects.map(function (project, index) {
                
                                            let _hasIteration = (project.publishedModelName != '' && project.publishedModelName != null);
                                            let _hasRepresentivePicture = (project.fileContent != '' && project.fileContent != null);
                
                                            return m("div", { "class": "customVision" }, [                
                                                m("div", { "class": "row" }, [
                                                    m("div", { "class": "col-md-2" },
                                                        !_hasRepresentivePicture && m('img.userImg[src="static/images/custom-vision/default.png"]', { "style": "width: 100%; min-height: 140px;" }),
                                                        _hasRepresentivePicture && m("img", { "src": project.fileContent, "style": "max-width: 100%;" })
                                                    ),
                                                    m("div", { "class": "col-md-7" }, [
                                                        m("span", { "class": "cvProjectTitle text-primary" }, project.name),
                                                        m("span", { "class": "cvProjectDescription text-secondary" }, project.description),
                                                        m("div", { "class": "row cvProjectLinks" }, [
                                                            m("div", { "class": "col-md-auto" }, m("a", { "href": "javascript:;", onclick:()=>{ _showListTagsPopup(project.id) } }, [m("i", { "class": "bi bi-tag" }), m("span", project.numberOfTags + " Tags...")])),
                                                            m("div", { "class": "col-md-auto" }, m("a", { "href": "javascript:;", onclick:()=>{ _showTrainingPhotosPage(project.id, project.name) } }, [m("i", { "class": "bi bi-card-image" }), m("span", project.numberOfImages + " Photos...")])),
                                                            m("div", { "class": "col-md-auto" }, m("a", { "href": "javascript:;", onclick:()=>{ _showListDisplaysPopup(project.id) } }, [m("i", { "class": "bi bi-columns-gap" }), m("span", project.numberOfDisplays + " Displays...")]))
                                                        ]),
                                                        m("div", { "class": "row cvProjectOperations" }, [
                                                            m("div", { "class": "col-md-auto" }, m("a", { "href": "javascript:;", onclick:()=>{ _showListIterationsPopup(project.id) } }, [m("i", { "class": "bi bi-clipboard-data" }), m("span", "Train...")])),
                                                            m("div", { "class": "col-md-auto" }, m("a", { "href": "javascript:;", onclick:()=>{ _showEditProjectPopup(project.id) } }, [m("i", { "class": "bi bi-pencil" }), m("span", "Edit...")])),
                                                            m("div", { "class": "col-md-auto" }, m("a", { "href": "javascript:;", onclick:()=>{ _showDeleteProjectConfirmation(project.id) }, "class": "text-danger" }, [m("i", { "class": "bi bi-trash" }), m("span", "Delete...")]))
                                                        ])
                                                    ]),
                                                    m("div", { "class": "col-md-3" }, [
                                                        m("div", { "class": "row cvProjectSideInfo" }, [
                                                            m("div", { "class": "col-md-auto" }, m("i", { "class": "bi bi-clock", "style": "font-size: 1.6em;" })),
                                                            m("div", { "class": "col-md-auto" }, m("div", { "style": "font-size: 0.8em;" }, [
                                                                m("div", "Created Date"),
                                                                m("div", project.createDateDisplay)
                                                            ])),
                                                        ]),
                                                        _hasIteration && m("div", { "class": "row cvProjectSideInfo" }, [
                                                            m("div", { "class": "col-md-auto" }, m("i", { "class": "bi bi-clipboard-data", "style": "font-size: 1.6em;" })),
                                                            m("div", { "class": "col-md-auto" }, m("div", { "style": "font-size: 0.8em;" }, [
                                                                m("div", project.publishedModelName),
                                                                m("div", project.iterationUpdateDateDisplay)
                                                            ])),
                                                        ])
                                                    ]),
                                                ]),
                                                m("hr")
                                            ])
                                        })
                                    ])
                                ),
                                this.getBaseViews()
                            ])
                        )
                    )
                ),
                m(Dialog, {
                    isOpen: isPopupAddNewProjectOpened,
                    transitionDuration: 200,
                    closeOnOutsideClick: false,
                    onClose: () => { isPopupAddNewProjectOpened = false; },
                    title: this.getText("LT00000058", "Create"),
                    content: m(CVProjectAddView, { 
                        onPopupClose: ()=>{ isPopupAddNewProjectOpened = false; },
                        onSaveComplete: onCreateNewProjectComplete
                    }),
                    "class": "cui-dialog-xxl"
                }),
                m(Dialog, {
                    isOpen: isPopupEditProjectOpened,
                    transitionDuration: 200,
                    closeOnOutsideClick: false,
                    onClose: () => { isPopupEditProjectOpened = false; },
                    title: this.getText("LT00000128", "Edit"),
                    content: m(CVProjectEditView, { 
                        onPopupClose: ()=>{ isPopupEditProjectOpened = false; },
                        onSaveComplete: onEditProjectComplete,
                        projectId: selectedProjectId
                    }),
                    "class": "cui-dialog-xxl"
                }),
                m(Dialog, {
                    isOpen: isPopupListTagsOpened,
                    transitionDuration: 200,
                    closeOnOutsideClick: false,
                    onClose: () => { isPopupListTagsOpened = false; _loadProjects(); },
                    title: this.getText("LT00000136", "Tags"),
                    content: m(CVTagsListView,{ projectId: selectedProjectId }),
                    "class": "cui-dialog-xxl",
                    footer: [

                        m('.d-flex.justify-content-end', 
                            m(Button, {
                                label: this.getText("LT00000021", "Close"),
                                onclick: () => { isPopupListTagsOpened = false; _loadProjects(); },
                                intent: 'primary'
                            })
                        ),
                      ]
                      
                }),
                m(Dialog, {
                    isOpen: isPopupListDisplaysOpened,
                    transitionDuration: 200,
                    closeOnOutsideClick: false,
                    onClose: () => { isPopupListDisplaysOpened = false; _loadProjects(); },
                    title: this.getText("LT00000136XX", "Displays"),
                    content: m(CVDisplaysListView,{ projectId: selectedProjectId }),
                    "class": "cui-dialog-xxl",
                    footer: [

                        m('.d-flex.justify-content-end', 
                            m(Button, {
                                label: this.getText("LT00000021", "Close"),
                                onclick: () => { isPopupListDisplaysOpened = false; _loadProjects(); },
                                intent: 'primary'
                            })
                        ),
                      ]
                      
                }),
                m(Dialog, {
                    isOpen: isPopupListIterationsOpened,
                    transitionDuration: 200,
                    closeOnOutsideClick: false,
                    onClose: () => { isPopupListIterationsOpened = false; },
                    title: this.getText("LT00000136XX", "Iterations"),
                    content: m(CVIterationsListView, { projectId: selectedProjectId }),
                    "class": "cui-dialog-xxl",
                    footer: [

                        m('.d-flex.justify-content-end', 
                            m(Button, {
                                label: this.getText("LT00000021", "Close"),
                                onclick: () => { isPopupListIterationsOpened = false; },
                                intent: 'primary'
                            })
                        ),
                      ]
                      
                }),
            ]);
        },
    };
}
